document.addEventListener('click', async function (e) {

  const btn = e.target.closest('.combo-add-btn');

  if (!btn) return;

  btn.classList.add('loading');
  btn.disabled = true;

  try {

    const payload = JSON.parse(
      document.getElementById(
        'combo-data-' + btn.dataset.combo
      ).textContent
    );

    const addResponse = await fetch('/cart/add.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify(payload)
    });

    if (!addResponse.ok) {
      throw new Error('Cart add failed');
    }

    const cartResponse = await fetch('/cart.js');
    const cart = await cartResponse.json();

    document.dispatchEvent(
      new CustomEvent('cart:update', {
        bubbles: true,
        detail: {
          resource: cart,
          sourceId: 'combo-offers',
          data: {
            source: 'combo-offers'
          }
        }
      })
    );

    const cartDrawer =
      document.querySelector('cart-drawer-component');

    if (cartDrawer && typeof cartDrawer.open === 'function') {
      cartDrawer.open();
    }

  } catch (error) {

    console.error(error);

  }

  btn.classList.remove('loading');
  btn.disabled = false;

});







document.addEventListener('DOMContentLoaded', () => {
  const comboSections = document.querySelectorAll('.bundle-offers');

  comboSections.forEach(section => {
    const slider = section.querySelector('.bundle-slider');
    const dots = section.querySelectorAll('.bundle-dot');
    const cards = section.querySelectorAll('.bundle-card');

    if (!slider || dots.length === 0 || cards.length === 0) return;

    // ==========================================
    // 1. DOT NAVIGATION & ACTIVE DOT UPDATES
    // ==========================================
    
    dots.forEach((dot, index) => {
      dot.addEventListener('click', () => {
        cards[index].scrollIntoView({
          behavior: 'smooth',
          block: 'nearest',
          inline: 'start'
        });
      });
    });

    const observerOptions = {
      root: slider,
      threshold: 0.6 
    };

    const observer = new IntersectionObserver((entries) => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          const activeIndex = Array.from(cards).indexOf(entry.target);
          dots.forEach(d => d.classList.remove('active'));
          if (dots[activeIndex]) {
            dots[activeIndex].classList.add('active');
          }
        }
      });
    }, observerOptions);

    cards.forEach(card => observer.observe(card));

    // ==========================================
    // 2. MOUSE DRAG TO SCROLL (DESKTOP)
    // ==========================================
    
    let isDown = false;
    let startX;
    let scrollLeft;

    slider.addEventListener('mousedown', (e) => {
      isDown = true;
      slider.classList.add('active');
      // Record starting positions
      startX = e.pageX - slider.offsetLeft;
      scrollLeft = slider.scrollLeft;
      
      // Temporarily disable CSS snap while dragging for a smoother feel
      slider.style.scrollSnapType = 'none'; 
    });

    slider.addEventListener('mouseleave', () => {
      isDown = false;
      slider.classList.remove('active');
      slider.style.scrollSnapType = ''; // Restore snap
    });

    slider.addEventListener('mouseup', () => {
      isDown = false;
      slider.classList.remove('active');
      slider.style.scrollSnapType = ''; // Restore snap, which will snap to nearest card
    });

    slider.addEventListener('mousemove', (e) => {
      if (!isDown) return; // Stop the fn from running if not clicked
      e.preventDefault(); 
      
      const x = e.pageX - slider.offsetLeft;
      const walk = (x - startX) * 1.5; // Multiply by 1.5 to scroll a bit faster than mouse movement
      slider.scrollLeft = scrollLeft - walk;
    });

  });
});